// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1kAzj","modalFooterButton":"ModalNotes_modalFooterButton__lvKi7"};